import { render, staticRenderFns } from "./IntroScreen.vue?vue&type=template&id=a1b71ea2&"
import script from "./IntroScreen.vue?vue&type=script&lang=js&"
export * from "./IntroScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports